
import WDCard from './wd-card';
import WDListSort from '../lists/wd-list-sort';
import WDNavbar from '../navbar/wd-navbar';

export default class WDCardList extends WDCard
{

	#config;
	#list;
	#filters;

	constructor(cfg)
	{
		super(cfg).classList.add('wd-card-list');

		this.#config = Object.assign({}, cfg);
	};

	get config() { return this.#config; };
	get proxy() { return this.#list.proxy; };
	get fetch() { return this.#list.fetch; };
	get results() { return this.#list.results; };
	get list() { return this.#list; };
	
	reqList(cfg)
	{
		return new Promise((resolve, reject) =>
		{
			//init the list
			this.buildList(cfg);

			if (cfg?.fetch)
			{
				this.runFetch().then(() =>
				{
					resolve(this.#list.proxy);
				});
			}
			else
			{
				resolve(this.#list.proxy);
			}
		});
	};
	
	buildList(cfg)
	{
		if (this.#list) this.#list.remove();

		this.#list = new WDListSort(cfg);
		this.#list.classList.add('scrollable');
		this.body.append(this.#list);

		//I can't decide on naming yet
		if (cfg.filters) this.buildFilters(cfg.filters);
	};

	get filters() { return this.#filters; };
	buildFilters(cfg)
	{
		this.#filters = this.header.navbar.addFilters({
			filters:cfg
		});
		this.#filters.on('filter:apply', () => this.runFetch());
	};

	//legacy call
	refresh() { this.runFetch(); };

	runFetch()
	{
		const formData = {};

		if (this.#filters) formData.filters = this.#filters.value;

		//clean up our filter data to remove any nulls or empty values
		for (let key in formData)
		{
			const val = formData[key];

			//remove empty form data so it doesn't get passed to the api			
			if (val === null || String(val).length == 0) delete (this.fetch[key]);

			//otherwise set the value to pass along
			else this.fetch[key] = val;
		}

		//merge in sort data for the request - should this be done in 
		//WDListProxy since that's where the sorting is...
		if (this.#list?.sortField != null) this.fetch.sort_field = this.#list.sortField;
		if (this.#list?.sortDir != null) this.fetch.sort_dir = this.#list.sortDir;

		//run the search
		return this.#list.req();
	};

};

customElements.define('wd-card-list', WDCardList);
